module.exports = __webpack_public_path__ + "static/media/intro.254f2ffe.mp3";